import { Field, ID, InputType, ObjectType } from 'type-graphql'
import { modelOptions, Prop, Severity } from '@typegoose/typegoose'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
@InputType('ProductMetadataInput')
@modelOptions({ options: { allowMixed: Severity.ALLOW } })
export class ProductMetadata {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('pmeta') })
  _id?: string

  @Field(() => String)
  @Prop({ type: String })
  key: string

  @Field(() => String)
  @Prop() //because this field should be stored as any type, we do provide here a value
  value: any

  @Field(() => String)
  @Prop() //just like this value field, is the raw value the original daw that can
  rawValue?: any

  @Field(() => String)
  @Prop({ type: String })
  description?: string

  @Field(() => String)
  @Prop({ type: String })
  unit: string
}
